<template>
  <PageManager
    :iframe-target="`${link}/contact`"
    page="contact"
  />
</template>

<script>

import PageManager from "@/components/SideEditor/PageManager"

import { mapGetters } from "vuex"

export default {
  components: {
    PageManager,
  },
  computed: {
    ...mapGetters({
      link: 'editor/fullDomainLink',
    }),
  },
}

</script>
